import { createAsyncThunk } from '@reduxjs/toolkit';

import { appApi, ratesApi, reservesApi } from 'src/api';

import { setContactUsErrors, setExchangeDirectionsMeta } from './app.slice';

import { normalizeErrorResponse } from 'src/utils';
import { toast } from 'react-toastify';

export const createContactEmail = createAsyncThunk(
  'app/create-contact-email',
  async (data, thunkApi) => {
    try {
      const { payload, setForm } = data;

      const response = await appApi.createContactEmail(payload);

      thunkApi.dispatch(setContactUsErrors({}));

      setForm({
        name: '',
        contact: '',
        message: '',
      });

      toast(response?.message, { type: 'success', position: 'top-right' });

      return response?.data;
    } catch (error) {
      console.error(error);
      const { response } = error;

      thunkApi.dispatch(setContactUsErrors(normalizeErrorResponse(response.data.errors)));
    }
  },
);

export const getReserves = createAsyncThunk('app/get-reserves', async (data, thunkApi) => {
  try {
    const response = await reservesApi.getReserves(data);

    return response?.data;
  } catch (error) {
    console.error(error);
  }
});

export const getExchangeDirections = createAsyncThunk(
  'app/get-exchange-directions',
  async (data, thunkApi) => {
    try {
      const response = await ratesApi.getRates(data);

      thunkApi.dispatch(setExchangeDirectionsMeta(response?.meta));

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const setAppLanguage = createAsyncThunk('app/set-language', async (data, thunkApi) => {
  try {
    const response = await appApi.setLanguage(data);

    return response?.data;
  } catch (error) {
    console.error(error);
  }
});
